import script from "./ColumnMixin.vue?vue&type=script&lang=js"
export * from "./ColumnMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__